export const options = [
  { value: 'Referrals', label: 'Referrals' },
  { value: 'Outreach/Users', label: 'Outreach/Users' },
  { value: 'Program Metrics', label: 'Program Metrics' },
  { value: 'Advisor Metrics', label: 'Advisor Metrics' },
  { value: 'Benefits', label: 'Benefits' },
  { value: 'Organization', label: 'Organization' },
  { value: 'Invite Users', label: 'Invite Users' },
];

export const values = options.map((option) => option.value);
